import Intro from "./intro";
import Modules from "./modules";
import type { ReactNode } from "react";

export default function Section(props: {
  number?: number;
  title: string;
  headline: ReactNode;
  colorPrimary: string;
  children: ReactNode;
  icon: () => JSX.Element;
}) {
  return (
    <section
      data-track-id={`product.section-${props.title.toLowerCase()}`}
      id={props.title.toLowerCase()}
    >
      <Intro {...props} />
      <Modules {...props}>{props.children}</Modules>
      <style jsx>{`
        section {
          scroll-margin-top: 60px;
        }
        @media (min-width: 520px) {
          section {
            scroll-margin-top: 108px;
          }
        }
      `}</style>
    </section>
  );
}
